export default function ResumeSection({ children }) {
  return <>
           <h5 className='display-5 text-center'>
             { children }
           </h5>
           <hr/>
         </>
}
